import React, { useState,useEffect } from "react";
import bookingpet from "../../assets/images/booking-pet.png";
import { IoIosStar } from "react-icons/io";
import { RiDownload2Fill } from "react-icons/ri";
import { SlCalender } from "react-icons/sl";
import Review from "../Review"
import axios from "axios";
import {jwtDecode} from "jwt-decode";
// import jsPDF from 'jspdf';
import html2pdf from 'html2pdf.js';
// import logo from "../../assets/images/fursure-logo.webp"
// import checkIcon from "../../assets/images/check_icon.png";
// import storeImg from "../../assets/images/storeimg.jpg";
import nobooking from "../../assets/images/nobooking.png"
import pdfimage from "../../assets/images/pdf.png"
import termimage from "../../assets/images/term.png"
import { GoDownload } from "react-icons/go";
import { Link } from "react-router-dom";
import Chat from "../Chatfile"
import config from "../../config";

const BookingStatus = () => {
  const [activeTab, setActiveTab] = useState("Past");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const token = localStorage.getItem("token");
  const decoded = jwtDecode(token);
  let id = decoded.data.customer_data.id;
  const [sellerIdForReview, setSellerIdForReview] = useState(null);
  const [ischatModalOpen, setIschatModalOpen] = useState(false);
  const[sellerId,setSellerId]=useState(null)
  const[sellerImage,setSellerImage]=useState(null)
  const[sellerName,setSellerName]=useState(null)
  const openchatModal = (id,name,image) => {

    setSellerId(id)
    setSellerImage(image);
    setSellerName(name)
    setIschatModalOpen(true);
  };
  const closechatModal = () => {
    setIschatModalOpen(false);
    
  };
  const openModal = (sellerId) => {
    setSellerIdForReview(sellerId);
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  
  };
  const [bookings, setBookings] = useState({
    Past: [],
    Confirmed: [],
    Upcoming: [],
  });
  const downloadPDF = (booking) => {
    const element = document.getElementById(`pdf-content-${booking.id}`);
    html2pdf().from(element).save(`booking-confirmation-${booking.id}.pdf`);
  };
  const openGoogleMaps = (address) => {
    const encodedAddress = encodeURIComponent(address.trim());
    const url = `https://www.google.com/maps?q=${encodedAddress}`;
    window.open(url, '_blank');
  };


  const renderBookings = (type) => {
 
    
    return bookings[type].map((booking) => {

      const isPastDate = new Date(booking.endDate).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0);
      
      if (type === "Past") {
        return (
          booking?
          <div
            key={booking.id}
            className="flex items-center justify-between p-2 border bg-[#F8F8F8] mb-2 border-[#0000004D] rounded"
          >
            <div className="flex items-center">
              <img
                src={booking.photographs}
                alt={booking.companyName}
                className="w-16 h-16 rounded-full mr-4"
              />
              <div>
                <h2 className="text-[16px] font-semibold">
                  {booking.companyName}
                </h2>
                <p className="text-gray-500 text-[14px] flex items-center"><SlCalender className="w-[20px] h-[20px] pr-2"/>{booking.date}</p>
                <p className="text-[16px] font-semibold">Booking Id: {booking.id}</p>
              </div>
            </div>
            <div>
              <h2 className="text-[16px]  font-semibold">Amount</h2>
              <p className="text-[14px] font-semibold">₹ {booking.price}</p>
            </div>
            <div className="flex items-center">
              <button className="flex items-center text-[#000] px-4 py-2 rounded-md border border-[#000] mr-2"  onClick={() => openModal(booking.sellerId)}>
                <IoIosStar className="text-[#F6C02D]" /> Rate & Review
              </button>
              <Link to={`https://findlocalpetservices.com/kennel-details/?id=${booking.sellerId}`}><button className="bg-[#FF6216] text-white px-4 py-2 rounded-md shadow-sm  focus:outline-none">
                Book Now
              </button></Link>
              <button className="ml-2 font-bold text-xl text-[#000]" onClick={() => downloadPDF(booking)}>
                <RiDownload2Fill />
              </button>
              <div className="p-4 hidden">
              <div id={`pdf-content-${booking.id}`} className="font-sans mx-auto bg-white p-6 pt-[100px]">
                     <div  className="flex justify-end items-center bg-[#FFE6A3] pt-[70px] pr-[4%]">
                     <GoDownload className="text-[#ff6216] border-4 border-[#ff6216] h-[30px] w-[40px] p-[5px]" style={{color:"#ff6216"}}/>
                     </div>
                      <div className="flex justify-between items-center bg-[#FFE6A3] w-full p-6 ">
                        <img src={pdfimage} className="h-20 w-20"/>
                       
                        <div className="w-[70%]">
                        <h1 className="text-center text-2xl font-bold mb-4">Thank you for booking with us</h1>
                        <div className="bg-[#fff] rounded-xl p-1">
                          <div  className="flex justify-between text-xs border-b border-[#000]">
                            <p className="text-xs p-1 text-[#7A7A7A] font-[500]">Booking ID: <span className="font-[500] text-[#4D4D4D]">{booking.id}</span></p>
                            <p className="text-xs p-1 text-[#7A7A7A] font-[500]">Date: <span className="font-[500] text-[#4D4D4D]">{`${String(new Date(booking.cdate).getDate()).padStart(2, '0')}-${String(new Date(booking.cdate).getMonth() + 1).padStart(2, '0')}-${new Date(booking.cdate).getFullYear()}`}</span></p>
                          </div>
                          <div className="mt-2 text-xs">
                            <p className="text-xs p-1 text-[#7A7A7A] font-[500] flex justify-between"><strong>Check In:</strong> <span className="font-[500] text-[#4D4D4D]">{`${String(new Date(booking.startDate).getDate()).padStart(2, '0')}-${String(new Date(booking.startDate).getMonth() + 1).padStart(2, '0')}-${new Date(booking.startDate).getFullYear()}`}</span></p>
                            <p className="text-xs p-1 text-[#7A7A7A] font-[500] flex justify-between"><strong>Check Out:</strong> <span className="font-[500] text-[#4D4D4D]">{`${String(new Date(booking.endDate).getDate()).padStart(2, '0')}-${String(new Date(booking.endDate).getMonth() + 1).padStart(2, '0')}-${new Date(booking.endDate).getFullYear()}`}</span></p>
                            <p className="text-xs p-1 text-[#7A7A7A] font-[500] flex  justify-between items-center"><strong>Services:</strong> 
                            
                            <span className="font-[500] text-[#4D4D4D]">{booking.service
    .map((item) => {
      if (
        [
          "Dog Small Boarding",
          "Dog Medium Boarding",
          "Dog Large Boarding",
          "Dog Giant Boarding",
        ].includes(item.Name)
      ) {
        return "Boarding";
      }
      return item.Name; // Return the original name if it doesn't match the conditions
    })
    .join(", ")}</span></p>
                          </div>
                        </div>
          
                        <div className="bg-[#fff] rounded-xl p-1 mt-2">
                          <div  className="flex justify-between text-xs border-b border-[#000]">
                            <p className="text-xs p-1 text-[#7A7A7A] font-[500]">Vendor Details</p>
              
                          </div>
                          <div className="mt-2 text-xs">
                            <p className="text-xs p-1 text-[#7A7A7A] font-[500] flex justify-between"><strong>Name: </strong> <span className="font-[500] text-[#4D4D4D]">{booking.companyName}</span></p>
                            <p className="text-xs p-1 text-[#7A7A7A] font-[500] flex justify-between"><strong>Phone Number:</strong> <span className="font-[500] text-[#4D4D4D]">{booking.vendorContact}</span></p>
                            <p className="text-xs p-1 text-[#7A7A7A] font-[500] flex justify-between"><strong>Address:</strong> <span className="font-[500] text-[#4D4D4D]"><p className="w-[270px]">{booking.address}</p></span></p>
                            <p className="text-xs p-1 text-[#7A7A7A] font-[500] flex  justify-between items-center"><strong>Service Type:</strong> 
                            
                            <span className="font-[500] text-[#4D4D4D]">{booking.service
    .map((item) => {
      if (
        [
          "Dog Small Boarding",
          "Dog Medium Boarding",
          "Dog Large Boarding",
          "Dog Giant Boarding",
        ].includes(item.Name)
      ) {
        return "Boarding";
      }
      return item.Name; // Return the original name if it doesn't match the conditions
    })
    .join(", ")}</span></p>
                                <p className="text-xs p-1 text-[#7A7A7A] font-[500] flex  justify-between items-center"><strong>Service booked for:</strong> 
                            
                                <span className="font-[500] text-[#4D4D4D]">{booking.service.map((item) => item.petType).join(", ")}</span></p>
                            <p className="text-xs p-1 text-[#7A7A7A] font-[500] flex justify-between"><strong>Message:</strong> <span className="font-[500] text-[#4D4D4D]">{booking.message?booking.message:"Data not found"}</span></p>
                            <p className="text-xs p-1 text-[#7A7A7A] font-[500] flex justify-between"><strong>Payment Amount:</strong><span className="font-[500] text-[#4D4D4D]">₹ {booking.price}</span></p>
          
                          </div>
                        </div>
          
                        <div className="bg-[#fff] rounded-xl p-1 mt-2">
                          <div  className="flex justify-between text-xs border-b border-[#000]">
                            <p className="text-xs p-1 text-[#7A7A7A] font-[500]">Pet Parent</p>
              
                          </div>
                          <div className="mt-2 text-xs">
                            <p className="text-xs p-1 text-[#7A7A7A] font-[500] flex justify-between"><strong>Customer Name: </strong> <span className="font-[500] text-[#4D4D4D]">{booking.name}</span></p>
                            <p className="text-xs p-1 text-[#7A7A7A] font-[500] flex justify-between"><strong>Phone Number:</strong> <span className="font-[500] text-[#4D4D4D]">{booking.number}</span></p>
                            <p className="text-xs p-1 text-[#7A7A7A] font-[500] flex  justify-between items-center"><strong>Service Type:</strong> 
                            
                            <span className="font-[500] text-[#4D4D4D]">{booking.service
    .map((item) => {
      if (
        [
          "Dog Small Boarding",
          "Dog Medium Boarding",
          "Dog Large Boarding",
          "Dog Giant Boarding",
        ].includes(item.Name)
      ) {
        return "Boarding";
      }
      return item.Name; // Return the original name if it doesn't match the conditions
    })
    .join(", ")}</span></p>
                            <p className="text-xs p-1 text-[#7A7A7A] font-[500] flex justify-between"><strong>Pet name:</strong> <span className="font-[500] text-[#4D4D4D]">{booking.petName}</span>
                              </p>
                            <p className="text-xs p-1 text-[#7A7A7A] font-[500] flex justify-between"><strong>Pet Weight:</strong> <span className="font-[500] text-[#4D4D4D]">{booking.breed=="small"?"0-10kg":booking.breed=="medium"?"11-20kg":booking.breed=="large"?"21-40kg":"40+kg"}</span></p>
          
                          </div>
                        </div>
          
                        <div>
                        <h1 className="text-lg font-[500] mb-4 ml-10">
                          Cancellation Policy</h1>
                          <div className="flex items-start">
                            <img src={termimage} />
                            <p className="text-xs">At FLIPS, we aim to provide a hassle-free experience for both pet parents and vendors. However, we understand that plans can change. Our cancellation policy is designed to ensure transparency and fairness for everyone involved.
                            <br/>
                            <Link to="https://findlocalpetservices.com/cancellation-policy/" className="text-[#ff6216] font-[600]">Read More</Link><br/>
                            <Link to="https://findlocalpetservices.com/"><button className="bg-[#ff6216] text-[#fff] p-1 mt-2 font-[600]">
                            Keep Booking with Us
                            </button></Link></p>
                           
                          </div>
                          
                        </div>
          </div>
                          </div>
                        </div>
             
            </div>
            </div>
          </div>:""
        );
      } else {
        return (
          
          <div
            key={booking.id}
            className={`justify-between p-4 mb-2 rounded-lg ${
        isPastDate ? 'bg-gray-300 cursor-not-allowed' : 'bg-[#F8F8F8]'
      }`}
      style={isPastDate ? { pointerEvents: 'none', opacity: 0.6 } : {}}
          >
            <div className="flex justify-between">
              <div className="flex items-start">
                <img
                  src={booking.photographs}
                  alt={booking.companyName}
                  className="w-16 h-16 rounded-full mr-4"
                />
                <div>
                  <h2 className="text-[16px] font-semibold">
                    {booking.companyName}
                  </h2>
                  <p className="flex items-center text-gray-500 text-[13px] font-semibold"><SlCalender className="w-[20px] h-[20px] pr-2"/>{booking.date}</p>
                  <p className="text-[16px] font-semibold">Booking Id: {booking.id}</p>

                </div>
                
              </div>
              <div className="flex items-start">
              
             
                  <h2 className="text-[16px] font-semibold text-[#00a700]">
                    {booking.status=="3"?"Cancelled":""}
                  </h2>
                 
                
                
              </div>
              <div className="flex items-center">
                  <button className="bg-[#FF6216] text-white px-4 px-12 py-[8px] rounded-md shadow-sm  mr-2"  onClick={()=>openchatModal(booking.sellerId,booking.companyName,booking.photographs)}>
                    Chat
                  </button>
                  <button className="ml-2 font-bold text-xl text-[#000]"  onClick={() => downloadPDF(booking)}>
                    <RiDownload2Fill />
                  </button>
                </div>
            </div>
          
            <div className="border-t-2 border-grey my-2 flex justify-around pt-4">
            
              <p className="text-gray-500 text-[15px] font-[500] w-[60%]">
                Address:
                <p className="text-[16px] font-bold cursor-pointer" onClick={()=>openGoogleMaps(booking.companyName+", "+booking.address)}>
                  {booking.address} <br /><span className="text-[#FF6216] font-bold underline">Get Location</span>
                </p>
              </p>
              <p className="text-gray-500 text-[15px] font-[500] w-[20%]">
              
                Phone no. <br/><span className="text-[16px] font-bold">{booking.vendorContact}</span>
              </p>
              <p className="text-gray-500 text-[15px] font-[500] w-[20%]">
                Amount: <br/><span className="text-[16px] font-bold">₹ {booking.price}</span>
              </p>
            </div>
            
            <div className="p-4 hidden">
          <div id={`pdf-content-${booking.id}`} className="font-sans mx-auto bg-white p-6 pt-[100px]">
                     <div  className="flex justify-end items-center bg-[#FFE6A3] pt-[70px] pr-[4%]">
                     <GoDownload className="text-[#ff6216] border-4 border-[#ff6216] h-[30px] w-[40px] p-[5px]" style={{color:"#ff6216"}}/>
                     </div>
                      <div className="flex justify-between items-center bg-[#FFE6A3] w-full p-6 ">
                        <img src={pdfimage} className="h-20 w-20"/>
                       
                        <div className="w-[70%]">
                        <h1 className="text-center text-2xl font-bold mb-4">Thank you for booking with us</h1>
                        <div className="bg-[#fff] rounded-xl p-1">
                          <div  className="flex justify-between text-xs border-b border-[#000]">
                            <p className="text-xs p-1 text-[#7A7A7A] font-[500]">Booking ID: <span className="font-[500] text-[#4D4D4D]">{booking.id}</span></p>
                            <p className="text-xs p-1 text-[#7A7A7A] font-[500]">Date: <span className="font-[500] text-[#4D4D4D]">{`${String(new Date(booking.cdate).getDate()).padStart(2, '0')}-${String(new Date(booking.cdate).getMonth() + 1).padStart(2, '0')}-${new Date(booking.cdate).getFullYear()}`}</span></p>
                          </div>
                          <div className="mt-2 text-xs">
                            <p className="text-xs p-1 text-[#7A7A7A] font-[500] flex justify-between"><strong>Check In:</strong> <span className="font-[500] text-[#4D4D4D]">{`${String(new Date(booking.startDate).getDate()).padStart(2, '0')}-${String(new Date(booking.startDate).getMonth() + 1).padStart(2, '0')}-${new Date(booking.startDate).getFullYear()}`}</span></p>
                            <p className="text-xs p-1 text-[#7A7A7A] font-[500] flex justify-between"><strong>Check Out:</strong> <span className="font-[500] text-[#4D4D4D]">{`${String(new Date(booking.endDate).getDate()).padStart(2, '0')}-${String(new Date(booking.endDate).getMonth() + 1).padStart(2, '0')}-${new Date(booking.endDate).getFullYear()}`}</span></p>
                            <p className="text-xs p-1 text-[#7A7A7A] font-[500] flex  justify-between items-center"><strong>Services:</strong> 
                            
                            <span className="font-[500] text-[#4D4D4D]">{booking.service
    .map((item) => {
      if (
        [
          "Dog Small Boarding",
          "Dog Medium Boarding",
          "Dog Large Boarding",
          "Dog Giant Boarding",
        ].includes(item.Name)
      ) {
        return "Boarding";
      }
      return item.Name; // Return the original name if it doesn't match the conditions
    })
    .join(", ")}</span></p>
                          </div>
                        </div>
          
                        <div className="bg-[#fff] rounded-xl p-1 mt-2">
                          <div  className="flex justify-between text-xs border-b border-[#000]">
                            <p className="text-xs p-1 text-[#7A7A7A] font-[500]">Vendor Details</p>
              
                          </div>
                          <div className="mt-2 text-xs">
                            <p className="text-xs p-1 text-[#7A7A7A] font-[500] flex justify-between"><strong>Name: </strong> <span className="font-[500] text-[#4D4D4D]">{booking.companyName}</span></p>
                            <p className="text-xs p-1 text-[#7A7A7A] font-[500] flex justify-between"><strong>Phone Number:</strong> <span className="font-[500] text-[#4D4D4D]">{booking.vendorContact}</span></p>
                            <p className="text-xs p-1 text-[#7A7A7A] font-[500] flex justify-between"><strong>Address:</strong> <span className="font-[500] text-[#4D4D4D]"><p className="w-[270px]">{booking.address}</p></span></p>
                            <p className="text-xs p-1 text-[#7A7A7A] font-[500] flex  justify-between items-center"><strong>Service Type:</strong> 
                            
                            <span className="font-[500] text-[#4D4D4D]">{booking.service
    .map((item) => {
      if (
        [
          "Dog Small Boarding",
          "Dog Medium Boarding",
          "Dog Large Boarding",
          "Dog Giant Boarding",
        ].includes(item.Name)
      ) {
        return "Boarding";
      }
      return item.Name; // Return the original name if it doesn't match the conditions
    })
    .join(", ")}</span></p>
                                <p className="text-xs p-1 text-[#7A7A7A] font-[500] flex  justify-between items-center"><strong>Service booked for:</strong> 
                            
                                <span className="font-[500] text-[#4D4D4D]">{booking.service.map((item) => item.petType).join(", ")}</span></p>
                            <p className="text-xs p-1 text-[#7A7A7A] font-[500] flex justify-between"><strong>Message:</strong> <span className="font-[500] text-[#4D4D4D]">{booking.message?booking.message:"Data not found"}</span></p>
                            <p className="text-xs p-1 text-[#7A7A7A] font-[500] flex justify-between"><strong>Payment Amount:</strong><span className="font-[500] text-[#4D4D4D]">₹ {booking.price}</span></p>
          
                          </div>
                        </div>
          
                        <div className="bg-[#fff] rounded-xl p-1 mt-2">
                          <div  className="flex justify-between text-xs border-b border-[#000]">
                            <p className="text-xs p-1 text-[#7A7A7A] font-[500]">Pet Parent</p>
              
                          </div>
                          <div className="mt-2 text-xs">
                            <p className="text-xs p-1 text-[#7A7A7A] font-[500] flex justify-between"><strong>Customer Name: </strong> <span className="font-[500] text-[#4D4D4D]">{booking.name}</span></p>
                            <p className="text-xs p-1 text-[#7A7A7A] font-[500] flex justify-between"><strong>Phone Number:</strong> <span className="font-[500] text-[#4D4D4D]">{booking.number}</span></p>
                            <p className="text-xs p-1 text-[#7A7A7A] font-[500] flex  justify-between items-center"><strong>Service Type:</strong> 
                            
                            <span className="font-[500] text-[#4D4D4D]">{booking.service
    .map((item) => {
      if (
        [
          "Dog Small Boarding",
          "Dog Medium Boarding",
          "Dog Large Boarding",
          "Dog Giant Boarding",
        ].includes(item.Name)
      ) {
        return "Boarding";
      }
      return item.Name; // Return the original name if it doesn't match the conditions
    })
    .join(", ")}</span></p>
                            <p className="text-xs p-1 text-[#7A7A7A] font-[500] flex justify-between"><strong>Pet name:</strong> <span className="font-[500] text-[#4D4D4D]">{booking.petName}</span>
                              </p>
                            <p className="text-xs p-1 text-[#7A7A7A] font-[500] flex justify-between"><strong>Pet Weight:</strong> <span className="font-[500] text-[#4D4D4D]">{booking.breed=="small"?"0-10kg":booking.breed=="medium"?"11-20kg":booking.breed=="large"?"21-40kg":"40+kg"}</span></p>
          
                          </div>
                        </div>
          
                        <div>
                        <h1 className="text-lg font-[500] mb-4 ml-10">
                          Cancellation Policy</h1>
                          <div className="flex items-start">
                            <img src={termimage} />
                            <p className="text-xs">At FLIPS, we aim to provide a hassle-free experience for both pet parents and vendors. However, we understand that plans can change. Our cancellation policy is designed to ensure transparency and fairness for everyone involved.
                            <br/>
                            <Link to="https://findlocalpetservices.com/cancellation-policy/" className="text-[#ff6216] font-[600]">Read More</Link><br/>
                            <Link to="https://findlocalpetservices.com/"><button className="bg-[#ff6216] text-[#fff] p-1 mt-2 font-[600]">
                            Keep Booking with Us
                            </button></Link></p>
                           
                          </div>
                          
                        </div>
          </div>
                          </div>
                        </div>
           
          </div>
          </div>
        );
      }

    });
  };
  const rendermobileBookings = (type) => {
    return bookings[type].map((booking) => {
      if (type === "Past") {
        return (
          <div
            key={booking.id}
            className="block items-center justify-between p-2 border bg-[#F8F8F8] mb-2 border-[#0000004D] rounded"
          >
            <div className="flex items-center py-2 justify-between">
              <img
                src={booking.photographs}
                alt={booking.companyName}
                className="w-16 h-16 rounded-full mr-4"
              />
              <div>
                <h2 className="text-[16px] font-semibold">
                  {booking.companyName}
                </h2>
                <p className="text-gray-500 text-[14px] flex items-center"><SlCalender className="w-[20px] h-[20px] pr-2"/>{booking.date}</p>
                <p className="text-[13px] font-semibold">Booking Id: {booking.id}</p>
              </div>
              <button className="ml-5 font-bold text-xl text-[#000]" onClick={() => downloadPDF(booking)}>
                <RiDownload2Fill />
              </button>
            </div>
            <div className="py-2">
              <h2 className="text-[16px]  font-semibold">Amount:₹ {booking.price}</h2>
              
            </div>
            <div className="flex items-center py-2 justify-between">
            <button className="flex items-center text-[#000] px-4 py-2 rounded-md border border-[#000] mr-2"  onClick={() => openModal(booking.sellerId)}>
            <IoIosStar className="text-[#F6C02D]" /> Rate & Review
          </button>
              
              <Link to={`https://findlocalpetservices.com/kennel-details/?id=${booking.sellerId}`}><button className="bg-[#FF6216] text-white px-4 py-2 rounded-md shadow-sm  focus:outline-none">
              Book Now
              </button>
              </Link>
              
            </div>
          </div>
        );
      } else {
        return (
          <div
            key={booking.id}
            className="block items-center justify-between p-2 border bg-[#F8F8F8] mb-2 border-[#0000004D] rounded"
          >
            <div className="flex items-center py-2 justify-between">
              <img
                src={bookingpet}
                alt={booking.companyName}
                className="w-16 h-16 rounded-full mr-4"
              />
              <div>
                <h2 className="text-[16px] font-semibold">
                  {booking.companyName}
                </h2>
                <p className="text-gray-500 text-[14px] flex items-center"><SlCalender className="w-[20px] h-[20px] pr-2"/>{booking.date}</p>
                <p className="text-[13px] font-semibold">Booking Id: {booking.id}</p>
              </div>
              <button className="ml-5 font-bold text-xl text-[#000]" onClick={() => downloadPDF(booking)}>
                <RiDownload2Fill />
              </button>
            </div>
            
            
          
           
            <div className=" flex py-2 justify-between">
            <p className="text-[#000] text-[16px] font-[500]">
            Address:
            <p className="text-[16px] font-bold cursor-pointer" onClick={()=>openGoogleMaps(booking.companyName+", "+booking.address)}>
                  {booking.address} <br /><span className="text-[#FF6216] font-bold underline">Get Location</span>
                </p>
          </p>
          <p className="text-[16px]  font-semibold">
                Phone no. <br/><span className="font-bold">{booking.vendorContact}</span>
              </p>
            
            </div>
            <div className="my-2 flex py-2 justify-between">
             
            <p className="text-[16px]  font-semibold">
                Amount: <br/><span className="font-bold">₹ {booking.price}</span>
              </p>
              <div className="flex">
                  <button className="bg-[#FF6216] text-white px-8 py-2 rounded-md shadow-sm  focus:outline-none mr-2"  onClick={()=>openchatModal(booking.sellerId,booking.companyName,booking.photographs)}>
                    Chat
                  </button>
                  
                </div>
            </div>
          </div>
        );
      }
    });
  };
  useEffect(() => {
    const token = localStorage.getItem("token");
    const decoded = jwtDecode(token);
    let id = decoded.data.customer_data.id;
    const fetchBookings = async () => {
      try {
        const response = await axios.get(
          `${config.API_BASE_URL}/bookings/getcustomerbookings/${id}`
        );
        if (response.data.success) {
          setBookings(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching bookings data:", error);
      }
    };

    fetchBookings();
  }, []);

  return (
    <>
      <div className="pt-6 md:block hidden">
        <h1 className="text-2xl font-bold mb-4">Booking Status</h1>
        <div className="flex mb-6">
          {["Past", "Confirmed", "Upcoming"].map(
            (tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`flex-1 text-center py-2 px-4 font-semibold ${
                  activeTab === tab
                    ? "bg-[#FAC63B] text-[#000]"
                    : "bg-gray-200 text-[#000]"
                }`}
              >
                {tab}
              </button>
            )
          )}
        </div>
        <div className="bg-white  rounded-lg  overflow-y-auto">
        <div>
          {activeTab === "Past" ? (
            bookings.Past && bookings.Past.length === 0 ? (
              <p  className="text-center font-bold text-xl"><img src={nobooking}  className="block mx-auto"/><br />Nothing Pending!</p>
            ) : (
              renderBookings(activeTab)
            )
          ) : activeTab === "Confirmed" ? (
            bookings.Confirmed && bookings.Confirmed.length === 0 ? (
              <p  className="text-center font-bold text-xl"><img src={nobooking}  className="block mx-auto"/><br />Nothing Pending!</p>
            ) : (
              renderBookings(activeTab)
            )
          ) : activeTab === "Upcoming" ? (
            bookings.Upcoming && bookings.Upcoming.length === 0 ? (
              <p  className="text-center font-bold text-xl"><img src={nobooking}  className="block mx-auto"/><br />Nothing Pending!</p>
            ) : (
              renderBookings(activeTab)
            )
          ) : null}
        </div>

        </div>
      </div>
      <div className="p-0 md:hidden block">
        <h1 className="text-2xl font-bold mb-4">Booking Status</h1>
        <div className="flex mb-6 overflow-scroll text-nowrap">
          {["Past", "Confirmed", "Upcoming"].map(
            (tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`flex-1 text-center py-2 px-2 font-semibold ${
                  activeTab === tab ? "bg-[#FEF5DD] text-[#F6C02D]" : "bg-gray-200"
                }`}
              >
                {tab}
              </button>
            )
          )}
        </div>
        <div className="bg-white rounded-lg">
        <div>
          {activeTab === "Past" ? (
            bookings.Past && bookings.Past.length === 0 ? (
              <p  className="text-center font-bold text-xl"><img src={nobooking}  className="block mx-auto"/><br />Nothing Pending!</p>
            ) : (
              rendermobileBookings(activeTab)
            )
          ) : activeTab === "Confirmed" ? (
            bookings.Confirmed && bookings.Confirmed.length === 0 ? (
              <p  className="text-center font-bold text-xl"><img src={nobooking}  className="block mx-auto"/><br />Nothing Pending!</p>
            ) : (
              rendermobileBookings(activeTab)
            )
          ) : activeTab === "Upcoming" ? (
            bookings.Upcoming && bookings.Upcoming.length === 0 ? (
              <p  className="text-center font-bold text-xl"><img src={nobooking}  className="block mx-auto"/><br />Nothing Pending!</p>
            ) : (
              rendermobileBookings(activeTab)
            )
          ) : null}
        </div>
         
        </div>
      </div>
      {isModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[9999]">
          <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-3xl h-4/5 overflow-y-auto m-2">
            
            <Review onClose={closeModal} sellerId={sellerIdForReview}/>
          </div>
        </div>
      )}
      {ischatModalOpen && (
            
        <div className="bg-white rounded-lg shadow-md p-6 w-full max-w-[400px] h-[500px] overflow-y-auto fixed bottom-0 right-0 md:min-h-0 min-h-screen z-[99999]" style={{boxShadow:"0px 0px 10px #000"}}>
          
          <Chat onClose={closechatModal} sellerId={sellerId} sellerName={sellerName} sellerImage={sellerImage}/>
        
      </div>
    )}

    </>
  );
};

export default BookingStatus;
